export const LOAD_CART = "LOAD_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const LOAD_PRODUCTS = "LOAD_PRODUCTS";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const ADD_PRODUCT_COUNT = "ADD_PRODUCT_COUNT";
export const REMOVE_PRODUCT_COUNT = "REMOVE_PRODUCT_COUNT";
